import { ChatMetaStatus } from '../types';

export function buildMessagesCreateUrl({
  recipientId = '',
  productId = '',
}: {
  recipientId?: number | string;
  productId?: number | string | null;
}) {
  const query = new URLSearchParams({
    userId: String(recipientId),
    ...(productId && { productId: String(productId) }),
  });

  return `/messages/create?${query}`;
}

export function isProductBanned(status?: string) {
  if (!status) {
    return false;
  }

  return [
    ChatMetaStatus.SellerAndProductBanned,
    ChatMetaStatus.BuyerAndProductBanned,
    ChatMetaStatus.ProductBanned,
  ].includes(status as ChatMetaStatus);
}

export function isProductDeleted(status?: string) {
  if (!status) {
    return false;
  }

  return [
    ChatMetaStatus.BuyerBannedAndProductDeleted,
    ChatMetaStatus.ProductDeleted,
  ].includes(status as ChatMetaStatus);
}

export function isDepopOfficial(status?: string) {
  return status === ChatMetaStatus.DepopOfficial;
}

export function getProductWarningMessage(
  chat_meta_status: string,
  hasInactiveUserWithProduct: boolean
) {
  if (
    hasInactiveUserWithProduct ||
    chat_meta_status === ChatMetaStatus.SellerAndProductBanned
  ) {
    return 'ChatStatus.SellerBannedAndProductBanned';
  }
  if (chat_meta_status === ChatMetaStatus.ProductBanned) {
    return 'ChatStatus.BannedItem';
  }

  if (isProductDeleted(chat_meta_status)) {
    return 'ChatStatus.DeletedProduct';
  }
}

export function getReadOnlyMessage(chat_meta_status?: string) {
  if (
    [
      ChatMetaStatus.BuyerAndProductBanned,
      ChatMetaStatus.BuyerBanned,
      ChatMetaStatus.UserBanned,
      ChatMetaStatus.BuyerBannedAndProductDeleted,
    ].includes(chat_meta_status as ChatMetaStatus)
  ) {
    return 'ChatStatus.InactiveUser';
  }

  return 'ChatStatus.ReadOnlyMessage';
}

export function getDomesticShippingText(
  isOwnProduct: boolean,
  hasDepopShipping: boolean
) {
  if (isOwnProduct) {
    if (hasDepopShipping) {
      return 'ItemSummary.DepopShipping';
    }
    return 'ItemSummary.ManualShipping';
  }
  return false;
}
